import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Badge, Card, Heading, HStack, Icon, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { MY_SCO_PITCH_DECKS_QUERY } from '@src/components/sco/PitchDeckAuditor/gql/operations';
import { scoreColorPalette } from '@src/components/sco/PitchDeckAuditor/model/ratingMeta';
import { PitchDeckCardMenu } from '@src/components/sco/PitchDeckAuditor/start/PitchDeckCardMenu';
import { useCurrentUser } from '@src/hooks/useCurrentUser.ts';
import { useRouter } from 'next/navigation';
import { ReactNode } from 'react';
import { LuPresentation } from 'react-icons/lu';
const STATUS_LABEL: Record<string, {
  label: string;
  colorPalette: string;
}> = {
  uploaded: {
    label: 'Uploading',
    colorPalette: 'gray'
  },
  parsing: {
    label: 'Reading',
    colorPalette: 'orange'
  },
  classified: {
    label: 'Classifying',
    colorPalette: 'orange'
  },
  auditing: {
    label: 'Auditing',
    colorPalette: 'orange'
  },
  audited: {
    label: 'Audited',
    colorPalette: 'green'
  },
  failed: {
    label: 'Failed',
    colorPalette: 'red'
  }
};
export function PitchDeckList(t0) {
  const $ = _c(19);
  const {
    onOpen,
    renderEmpty
  } = t0;
  const {
    currentUser
  } = useCurrentUser();
  const router = useRouter();
  const t1 = currentUser?.userId || null;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      userId: t1,
      page: 1,
      pageSize: 20
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = !currentUser?.userId;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = {
      variables: t2,
      skip: t3,
      fetchPolicy: "cache-and-network"
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const query = useQuery(MY_SCO_PITCH_DECKS_QUERY, t4);
  let t5;
  if ($[5] !== query.data) {
    t5 = (query.data as any)?.scoPitchDecks ?? [];
    $[5] = query.data;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const decks = t5;
  if (!decks.length) {
    if (renderEmpty) {
      let t6;
      if ($[7] !== renderEmpty) {
        t6 = renderEmpty();
        $[7] = renderEmpty;
        $[8] = t6;
      } else {
        t6 = $[8];
      }
      return t6;
    } else {
      return null;
    }
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      base: 1,
      sm: 2
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== decks || $[11] !== onOpen || $[12] !== router) {
    let t8;
    if ($[14] !== onOpen || $[15] !== router) {
      t8 = deck => {
        const status = STATUS_LABEL[deck.statusKey] ?? {
          label: deck.statusKey,
          colorPalette: "gray"
        };
        const score = deck.latestPitchDeckAudit?.overallScore;
        const title = deck.latestPitchDeckAudit?.companyName || deck.title || "Pitch deck";
        return <Card.Root key={deck.pitchDeckId} _hover={{
          bg: "bg.muted"
        }} cursor="pointer" size="sm" variant="outline" onClick={() => onOpen ? onOpen(deck.pitchDeckId) : router.push(`/pitch-decks/${deck.pitchDeckId}`)}><Card.Body><HStack gap={2} mb={1}><Icon as={LuPresentation} boxSize={4} color="orange.fg" /><Heading flex={1} lineClamp={1} size="sm">{title}</Heading>{typeof score === "number" && <Badge colorPalette={scoreColorPalette(score)} size="sm" variant="surface">{score}</Badge>}<PitchDeckCardMenu pitchDeckId={deck.pitchDeckId} title={title} /></HStack><HStack gap={2}><Badge colorPalette={status.colorPalette} size="xs" variant="subtle">{status.label}</Badge><Text color="fg.muted" fontSize="xs">{deck.slideCount ?? 0} slides</Text></HStack></Card.Body></Card.Root>;
      };
      $[14] = onOpen;
      $[15] = router;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    t7 = decks.map(t8);
    $[10] = decks;
    $[11] = onOpen;
    $[12] = router;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <VStack align="stretch" gap={4} marginX="auto" width="full"><SimpleGrid columns={t6} gap={3}>{t7}</SimpleGrid></VStack>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}